<template>
  <div>
    <div v-if="showComponent" class="buy-btn-box">
      <el-input v-model="$$FormData.goods_buy_btn_text" placeholder="输入购买按钮文字" :maxlength="4" />
    </div>
    <div v-if="showCustomComponent" class="custom-upload">
      <div>
        <image-selector v-model="btnImage" />
        <p v-if="!$$FormData.buy_btn_style_image" class="tip-error">请上传按钮图片</p>
      </div>
      <p class="tip-upload">推荐使用20x20像素的.png图片</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoodsSettingCustomBuyBtn',
  data() {
    return {
      btnImage: ''
    }
  },
  watch: {
    /**
     * 订阅goods_buy_btn_style
     * 新值是3、7，设置购买按钮文字默认为"马上抢"
     * 新值是4、8，设置购买按钮文字默认为"购买"
     * 默认为空值
     * @param newVal
     */
    '$$FormData.goods_buy_btn_style'(newVal) {
      let goods_buy_btn_text = ''
      switch (newVal) {
        case 3:
        case 7:
          goods_buy_btn_text = '马上抢'; break;
        case 4:
        case 8:
          goods_buy_btn_text = '购买'; break;
        case 9:
          goods_buy_btn_text = '立即购买'; break;
        default:
          goods_buy_btn_text = ''
      }
      this.$$FormData.goods_buy_btn_text = goods_buy_btn_text
    },
    btnImage: {
      deep: true,
      immediate: false,
      handler(newVal) {
        this.$$FormData.buy_btn_style_image = newVal.src || ''
      }
    }
  },
  computed: {
    showComponent() {
      return [3, 4, 7, 8, 9].includes(this.$$FormData.goods_buy_btn_style);
    },
    showCustomComponent() {
      return [10].includes(this.$$FormData.goods_buy_btn_style);
    }
  },
  mounted() {
    this.btnImage = {
      src: this.$$FormData.buy_btn_style_image
    }
  }
}
</script>

<style lang="scss" scoped>
.buy-btn-box {
  margin-top: 12px;
}
.custom-upload {
  display: flex;
  align-items: flex-end;
  margin-top: 12px;
  line-height: normal;
  .upload-box,
  .custom-img {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    overflow: hidden;
    color: #155bd4;
    font-size: 20px;
    border: 1px solid #e5e5e5;
    background-color: #f2f4f6;
    cursor: pointer;
    .label-box {
      font-size: 12px;
      margin: 0;
      margin-top: 4px;
    }
  }
  .tip-error {
    margin-top: 5px;
    font-size: 12px;
    color: #d40000;
  }
  .tip-upload {
    color: #969799;
    margin-left: 10px;
    font-size: 12px;
  }
  .custom-img {
    position: relative;
    cursor: auto;
    .img-upload {
      width: 100%;
      height: 100%;
    }
    .change-btn {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 12px;
      color: #ffffff;
      background-color: rgba(0,0,0,.5);
      cursor: pointer;
    }
  }
}
</style>
